import { TreeNode } from 'primeng/api';
import { Dimension } from './dimension';
import { CriteriaGroup } from './criteria-group';
import { Item } from '../component/bi-analysis-result-view/bi-analysis-table/flat-table/model/item';
export class DimensionAttribute {
    id: string = '';
    dimensionId: string = '';
    caption: string = '';
    columnname?: string;
    hierarchicalFilter?: boolean;
    visibleFilter: boolean = false;        //show filter dialog
    filterOptions?: Item[];
    activeFilterValues?: string[];
    description?: string;
    factTableId?: string;
    defaultRelease?: string;
    // hierarchy member
    hierarchy: TreeNode<Dimension | DimensionAttribute>[] = [];
    isHierarchy?: boolean;
    hierarchyParentChildRelation?: Map<number, number>;
    hierarchyIDToValue?: Map<number, string>;
    conformedCaption?: string;
    criteriaGroups: CriteriaGroup[] = [];
    sortOrderColumn?: string;
    hidden?: boolean;
    custom?: boolean;
    position: number = 0;

    static getMockAttr( id: string, factTableId: string ): any {
        let attr = new DimensionAttribute();
        attr.id = id;
        attr.factTableId = factTableId;
        return attr;
    }

}
